import React from 'react';
import { slides } from '../../deckSlides';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { SlidePreview } from './SlidePreview';
import { DownloadStoryboardButton, StoryboardButton } from './Storyboard';

/** This slide's own id — filtered out so the storyboard never renders itself. */
const SELF_ID = 'scr_stb012';
export function StoryboardSlide() {
  const pages = (slides ?? []).filter(slide => slide.id !== SELF_ID);
  return <SlideFrame data-id="element-313" data-mp="2iazr2x0o79rw">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-314" data-mp="2dej0zx9wulc6">
        <SlideHeader eyebrow="Appendix — Storyboard" title="The full deck," accent="page by page" kicker="Snakker for LEO Pharma" data-id="element-315" data-mp="2ddzmyrndsh3f" />

        <ol className="mt-[2.4vh] grid min-h-0 flex-1 grid-cols-4 content-start gap-x-[1.2vw] gap-y-[1.8vh]" data-id="element-316" data-mp="2n4krswtnehus">
          {pages.map((slide, index) => <Reveal key={slide.id} delay={0.16 + index * 0.03} data-id="element-317" data-mp="2x2ig1kbicene" data-mpi={index}>
              <li data-id="element-318" data-mp="2x05nkd84ilw3">
                <div className="overflow-hidden rounded-[0.3vw] border border-white/20" data-id="element-319" data-mp="bn5di4x5go5i">
                  <SlidePreview screenId={slide.id} title={slide.title} data-id="element-320" data-mp="bpi39495g2t4" />
                </div>
                <p className={`${t.label} mt-[0.8vh] flex gap-[0.4vw] leading-[1.2] text-white/55`} data-id="element-321" data-mp="fqtnsvd61xug">
                  <span className="font-semibold text-[#A26BFF]" data-id="element-322" data-mp="png6pelxmetu">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="truncate" data-id="element-323" data-mp="ulrgxqg52rcl">{slide.title}</span>
                </p>
              </li>
            </Reveal>)}
        </ol>

        <Reveal delay={0.5} className="mt-[2vh] flex shrink-0 items-center justify-between gap-[2vw] border-t border-white/10 pt-[1.8vh]" data-id="element-324" data-mp="13dtdver01pi4">
          <p className={`${t.label} leading-[1.35] text-white/50`} data-id="element-325" data-mp="18f8wl05pfjxc">
            {pages.length} pages · strategy, proof, delivery model, platform, and
            operating model.
          </p>
          <span className="flex shrink-0 items-center gap-[0.8vw]" data-id="element-326" data-mp="1i9hlldvj0uqr">
            <StoryboardButton label="Open storyboard" data-id="element-327" data-mp="so84e5t5e51y" />
            <DownloadStoryboardButton label={`Download PDF · ${pages.length} pages`} data-id="element-328" data-mp="nolvg8kcrayy" />
          </span>
        </Reveal>
      </div>
    </SlideFrame>;
}